/**
 * 公共上传组件
 */
// 禁止上传的文件类型
var excludeFileType = ['sh', 'exe', 'com', 'bat', 'asm', 'res', 'java', 'js', 'class', 'php', 'jsp', 'asp', 'bak', 'bin', 'c', 'cfg', 'cmd', 'cpp', 'css', 'dat', 'err', 'fp', 'fxp', 'h', 'hqx', 'html', 'htm', 'inc', 'ini', 'sql', 'set', 'sys'];

var storageUtil = {
	/**
	 * 文件下载
	 * @param {Object} id
	 */
	downloadWj: function(id) {
		window.location.href = window.fdConfig.url.wj.download.replace("{id}",id);
	},
	//初始化文件列表信息
    initWjList: function(ywbh,ywlb,wjList){
        const _method = window.fdConfig.methodGet;
        const _url = window.fdConfig.url.wj.list;
        const _data = {
            limit:9999,
            ywbh:ywbh,
            ywlb:ywlb,
            sort:'-DT_CJSJ'
        };
        window.fdGlobal.ajax({
                method: _method,
                url: _url,
                // URL参数
                // 必须是一个纯对象或者 URL参数对象
                params: _data,
                // 默认值是json
                type: 'application/json',
                responseType: 'json'
            }).then((data) => {
                const _serverData = data.data.data;
                if(wjList){
                    wjList.splice(0,wjList.length);
                    for(var i=0;i<_serverData.length;i++){
                        wjList.push(_serverData[i]);
                    }
                }
            }, (data) => {
                const _serverData = data.data;
            });
    }
}

export default storageUtil;
